"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSourceParameterType = void 0;
var DataSourceParameterType;
(function (DataSourceParameterType) {
    DataSourceParameterType["NONE"] = "None";
    DataSourceParameterType["STRING"] = "String";
    DataSourceParameterType["INT"] = "Int";
    DataSourceParameterType["FLOAT"] = "Float";
    DataSourceParameterType["DATE_TIME"] = "DateTime";
    DataSourceParameterType["ARRAY_OF_STRINGS"] = "[String]";
    DataSourceParameterType["ARRAY_OF_INTS"] = "[Int]";
    DataSourceParameterType["ARRAY_OF_FLOATS"] = "[Float]";
})(DataSourceParameterType || (exports.DataSourceParameterType = DataSourceParameterType = {}));
//# sourceMappingURL=dataSource.js.map